import { render } from "./MainDichVu.vue?vue&type=template&id=2d5fa46a"
import script from "./MainDichVu.vue?vue&type=script&lang=js"
export * from "./MainDichVu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__